import { forwardRef, type InputHTMLAttributes } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

import { Label } from './Label';

type Props = InputHTMLAttributes<HTMLSelectElement> & {
  selectLabel?: string;
  label?: string;
  errorMessage?: string;
  options: OPTIONS[];
  notNullable?: boolean;
  containerClassName?: string;
};

export type OPTIONS = {
  label: string;
  value: number | string;
};

export const SelectInput = forwardRef<HTMLSelectElement, Props>(
  ({ label, id, selectLabel, errorMessage, options, notNullable, containerClassName, className, ...rest }, ref) => {
    return (
      <div className={containerClassName}>
        {label ? (
          <Label htmlFor={id} className={twJoin(!!errorMessage && 'text-red-700 dark:text-red-500')}>
            {label}
          </Label>
        ) : null}
        <select
          ref={ref}
          id={id}
          className={twMerge(
            'bg-gray-50 h-10 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500',
            !!errorMessage &&
              'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 dark:bg-gray-700 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500',
            className,
          )}
          {...rest}
        >
          {!notNullable ? <option value={''}>{selectLabel}</option> : null}
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {errorMessage ? <p className="mt-2 text-sm text-red-600 dark:text-red-500">{errorMessage}</p> : null}
      </div>
    );
  },
);

SelectInput.displayName = 'SelectInput';
